import React from "react";
import { formatDateToDMYHMALocal } from "../../../../utility/helpers";
import { getUserData } from "../../../../utility/utils";

const DataPart = ({ label, value, valueBold = false }) => {
    return (
        <div className="flex flex-row gap-x-1">
            <span className="">{label}:</span>
            <span className={valueBold ? "font-bold" : ""}>{value}</span>
        </div>
    );
};

const PassengerPart = ({ data, printedTime, counterName = "" }) => {
    return (
        <div className="flex flex-col w-full">
            <div className="flex flex-row pt-1">
                <div className="flex-1">
                    <DataPart label="Name" value={data?.passengerName} />
                </div>
                <div className="flex-1 relative">
                    <div className="absolute top-[7px]">
                        <img
                            src="/images/logo.png"
                            alt="bdtickets-logo"
                            width={75}
                            className="h-[45px]"
                        />
                    </div>
                </div>
            </div>
            <div className="flex-1 pt-1">
                <DataPart label="Address" value={data?.address} />
            </div>
            <div className="flex-1 pt-1">
                <DataPart label="Mobile" value={data?.msisdn} />
            </div>
            <div className="flex flex-row pt-1">
                <div className="flex-1">
                    <DataPart label="Ticket No" value={data?.ticketNumber} />
                </div>
                <div className="flex-1">
                    <DataPart label="Gender" value={data?.gender} />
                </div>
            </div>
            <div className="flex flex-row pt-1">
                <div className="flex-1">
                    <DataPart
                        label="Journey Dt."
                        value={data?.journeyDate}
                        valueBold={true}
                    />
                </div>
                <div className="flex-1">
                    <DataPart label="Issue Dt." value={data?.issueDate} />
                </div>
            </div>
            <div className="flex flex-row pt-1">
                <div className="flex-1">
                    <DataPart label="From" value={data?.from} />
                </div>
                <div className="flex-1">
                    <DataPart label="To" value={data?.to} />
                </div>
            </div>
            <div className="flex flex-row pt-1">
                <div className="flex-1">
                    <DataPart
                        label="Reporting Time"
                        value={data?.reportingTime}
                    />
                </div>
                <div className="flex-1">
                    <DataPart
                        label="Departure Time"
                        value={data?.departureTime}
                        valueBold={true}
                    />
                </div>
            </div>
            <div className="flex flex-row pt-1">
                <div className="flex-1">
                    <DataPart label="Seat Fare(Tk)" value={data?.seatFare} />
                </div>
                <div className="flex-1">
                    <DataPart
                        label="Total Fare(Tk)"
                        value={data?.totalFare}
                        valueBold={true}
                    />
                </div>
            </div>
            <div className="flex flex-row pt-1">
                <div className="flex-1">
                    <DataPart label="Goods Fare(Tk)" value={data?.goodsFare} />
                </div>
                <div className="flex-1">
                    <DataPart
                        label="Grand Total Fare(Tk)"
                        value={data?.grandTotal}
                        valueBold={true}
                    />
                </div>
            </div>
            <div className="flex flex-row pt-1">
                <div className="flex-1">
                    <DataPart
                        label="Seat No."
                        value={data?.seats}
                        valueBold={true}
                    />
                </div>
                <div className="flex-1">
                    {/* <DataPart label="Discount" value={data?.discounts} /> */}
                    <DataPart
                        label="Coach No."
                        value={data?.tripNumber}
                        valueBold={true}
                    />
                </div>
            </div>
            {/* <div className="flex flex-row">
                <div className="flex-1">
                    <DataPart label="Counter" value={counterName} />
                </div>
                <div className="flex-1">
                    <DataPart label="User" value={data?.user} />
                </div>
            </div> */}
            <div className="flex flex-row justify-center pt-1">
                <DataPart
                    label="Issued by"
                    value={`${
                        getUserData()?.user?.name
                    }(${counterName}, ${formatDateToDMYHMALocal(printedTime)})`}
                />
            </div>
        </div>
    );
};

const OtherPart = ({ data, printedTime, counterName = "" }) => {
    return (
        <>
            <div className="flex flex-col w-full">
                <div className="flex flex-row">
                    <DataPart label="Name" value={data?.passengerName} />
                </div>
                <div className="flex flex-row gap-x-1 pt-1">
                    <div className="flex-1">
                        <DataPart label="Mobile" value={data?.msisdn} />
                    </div>
                    <div className="flex-1">
                        <DataPart label="Gender" value={data?.gender} />
                    </div>
                </div>
                <div className="flex flex-row gap-x-1 pt-1">
                    <div className="flex-1">
                        <DataPart label="Ticket#" value={data?.ticketNumber} />
                    </div>
                    <div className="flex-1">
                        <DataPart label="Age" value={data?.age} />
                    </div>
                </div>
                <div className="flex flex-row pt-1">
                    <DataPart
                        label="Coach No"
                        value={data?.tripNumber}
                        valueBold={true}
                    />
                </div>
                <div className="flex flex-row pt-1">
                    <DataPart
                        label="Journey Date"
                        value={data?.journeyDate}
                        valueBold={true}
                    />
                </div>
                {/* <div className="flex flex-row">
                    <DataPart label="Issue" value={data?.issueDate} />
                </div> */}
                <div className="flex flex-row pt-1">
                    <div className="flex-1">
                        <DataPart label="From" value={data?.from} />
                    </div>
                    <div className="flex-1">
                        <DataPart label="To" value={data?.to} />
                    </div>
                </div>
                <div className="flex-1 pt-1">
                    <DataPart
                        label="Departure Time"
                        value={data?.departureTime}
                        valueBold={true}
                    />
                </div>
                {/* <div className="flex flex-row">
                    <div className="flex-1">
                        <DataPart label="Rept" value={data?.reportingTime} />
                    </div>
                    <div className="flex-1">
                        <DataPart label="Dept" value={data?.departureTime} />
                    </div>
                </div> */}
                {/* <div className="flex flex-row">
                    <div className="flex-1">
                        <DataPart label="Fare" value={data?.seatFare} />
                    </div>
                    <div className="flex-1">
                        <DataPart label="Total" value={data?.totalFare} />
                    </div>
                </div> */}
                <div className="flex-1 pt-1">
                    <DataPart label="Seat Fare(Tk)" value={data?.seatFare} />
                </div>
                <div className="flex-1 pt-1">
                    <DataPart label="Goods Fare(Tk)" value={data?.goodsFare} />
                </div>
                <div className="flex-1 pt-1">
                    <DataPart
                        label="Total Fare(Tk)"
                        value={data?.grandTotal}
                        valueBold={true}
                    />
                </div>
                <div className="flex-1 pt-1">
                    <DataPart
                        label="Seat No."
                        value={data?.seats}
                        valueBold={true}
                    />
                </div>
                {/* <div className="flex flex-row">
                    <div className="flex-1">
                        <DataPart label="Seats" value={data?.seats} />
                    </div>
                    <div className="flex-1">
                        <DataPart label="Discount" value={data?.discounts} />
                    </div>
                </div> */}
                {/* <div className="flex flex-row">
                    <DataPart label="Counter" value={counterName} />
                </div>
                <div className="flex flex-row">
                    <DataPart label="User" value={data?.user} />
                </div> */}
                <div className="flex flex-row justify-center pt-1">
                    <DataPart
                        label="Issued By"
                        value={`${getUserData()?.user?.name}(${counterName})`}
                    />
                </div>
            </div>
        </>
    );
};

const Ticket = React.forwardRef(
    (
        { data, isPassengerPartMiddle, showForPrint = false, printedTime },
        ref
    ) => {
        const counterName =
            typeof data?.counter == "object"
                ? data?.counter?.title_en
                : data?.counter;
        return (
            <div
                ref={ref}
                className={`p-2 ${showForPrint ? "mt-16" : ""}`}
                style={{ fontSize: "10px" }}
            >
                {!isPassengerPartMiddle ? (
                    <div className="flex flex-row w-full">
                        <div
                            className={`p-2 ${
                                !showForPrint
                                    ? "border border-gray-400 border-r-0"
                                    : ""
                            }`}
                            style={{ width: "46%" }}
                        >
                            <PassengerPart
                                data={data}
                                printedTime={printedTime}
                                counterName={counterName}
                            />
                        </div>
                        <div
                            className={`p-2 ${
                                !showForPrint
                                    ? "border border-gray-400 border-r-0"
                                    : ""
                            }`}
                            style={{ width: "27%" }}
                        >
                            <OtherPart
                                data={data}
                                printedTime={printedTime}
                                counterName={counterName}
                            />
                        </div>
                        <div
                            className={`p-2 ${
                                !showForPrint ? "border border-gray-400" : ""
                            }`}
                            style={{ width: "27%" }}
                        >
                            <OtherPart
                                data={data}
                                printedTime={printedTime}
                                counterName={counterName}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="flex flex-row w-full">
                        <div
                            className={`p-2 ${
                                !showForPrint
                                    ? "border border-gray-400 border-r-0"
                                    : ""
                            }`}
                            style={{ width: "27%" }}
                        >
                            <OtherPart
                                data={data}
                                printedTime={printedTime}
                                counterName={counterName}
                            />
                        </div>
                        <div
                            className={`p-2 ${
                                !showForPrint
                                    ? "border border-gray-400 border-r-0"
                                    : ""
                            }`}
                            style={{ width: "46%" }}
                        >
                            <PassengerPart
                                data={data}
                                printedTime={printedTime}
                                counterName={counterName}
                            />
                        </div>
                        <div
                            className={`p-2 ${
                                !showForPrint ? "border border-gray-400" : ""
                            }`}
                            style={{ width: "27%" }}
                        >
                            <OtherPart
                                data={data}
                                printedTime={printedTime}
                                counterName={counterName}
                            />
                        </div>
                    </div>
                )}
            </div>
        );
    }
);

export default Ticket;
